import gqlTagGira from 'graphql-tag';

export const SCHEDULE_TIMELINE_ITEM_MUTATION = gqlTagGira`
    mutation ScheduleTimelineJwmItem($input: JWMScheduleTimelineItemInput!) {
        scheduleTimelineJwmItem(input: $input) {
            success
            errors {
                message
                extensions {
                    statusCode
                    errorType
                }
            }
        }
    }
`;
